export default __webpack_public_path__ + "static/ensino-fundamental-1f4261e538a8e58e58c861b98886ff9a.svg";